<template>
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <div v-show="etat === CONSTANT.etat.mfaoptions">
      <Titre
        :content="{
          titre: content.mfaTitre,
          type: 'grandTitre',
        }"
      ></Titre>

      <MessageMel
        v-show="contentMessageMel.message"
        :content="contentMessageMel"
        class="mt-n1 mt-md-0 mb-1"
      ></MessageMel>

      <Paragraphe
        :content="{
          richText: content.txtMFA,
          //classeCSS: 'pb-1',
        }"
      ></Paragraphe>

      <Hyperlien :content="contentLienAideMFA"></Hyperlien>

      <div class="row">
        <div class="col">
          <b-form
            :action="formAction"
            method="post"
            @click="setMFAOption($event)"
            @submit="onSubmit()"
          >
            <!-- mfaopref est passé dans le POST -->
            <input v-model="mfaOption" name="mfaopref" type="hidden" />

            <b-button
              id="buttonPrefYes"
              class="btn btn-primaire px-4 my-2 mx-auto mx-md-0 d-block"
              type="submit"
              :disabled="isSubmitted"
            >
              {{ content.txtActiverMFA }}
            </b-button>

            <b-button
              id="buttonPrefNo"
              class="lienSecondaire mb-2 mx-auto mx-md-0 d-block"
              type="submit"
              :disabled="isSubmitted"
            >
              {{ content.txtRefuserMFA }}
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import Hyperlien from '@/components/base/Hyperlien';
import MessageMel from '@/components/base/MessageMel';
import Titre from '@/components/base/Titre';
import Paragraphe from '@/components/base/Paragraphe';

// Helpers
import MessageHelpers from '@/helpers/MessageHelpers';

export default {
  name: 'Auth0MfaResetPassword',

  components: {
    MessageMel,
    Titre,
    Hyperlien,
    Paragraphe,
  },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      CONSTANT: {
        etat: {
          chargement: 'Chargement',
          erreur: 'Erreur',
          mfaoptions: 'MFAOptions',
        },
      },
      etat: 'MFAOptions',
      message: null,
      contentMessageMel: {
        message: null,
      },
      isSubmitted: false,
      formAction: '',
      formValid: false,
      urlState: '',
      userToken: this.$route.query.token,
    };
  },
  computed: {
    mfaOption: {
      get() {
        return this.$store.state.compte.mfaOption;
      },
      set(value) {
        this.$store.commit('compte/SET_MFA_OPTION', value);
      },
    },
    contentLienAideMFA() {
      return {
        texte: this.content.libTexteAideMFA,
        type: 'aide',
        lien: this.content.lien,
        classeCSS: 'text-left m-0 pb-2',
      };
    },
  },
  mounted() {
    this.etat = this.initEtat();
    this.inputValidation();
  },
  methods: {
    initEtat() {
      this.urlState = this.$route.query.state;
      if (!this.urlState) {
        const errorMSG = 'MSG01';
        this.afficherMessageErreur(errorMSG);

        return this.CONSTANT.etat.erreur;
      }

      // À ce point-ci, on assume qu'on veut demander le choix MFA
      this.formAction = `${process.env.VUE_APP_CIAM_DOMAIN}/continue?state=${this.urlState}`;
      return this.CONSTANT.etat.mfaoptions;
    },

    afficherMessageErreur(codeErreur) {
      MessageHelpers.obtenirMessage(codeErreur, this.$root)
        .then((msgResp) => {
          this.contentMessageMel.message = msgResp.msgDetail;
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },

    async onSubmit() {
      if (this.isSubmitted) {
        return;
      }

      this.isSubmitted = true;

      this.contentMessageMel.message = null;
    },

    async inputValidation() {
      // retrait de MessageMel provenant d'un submit précédant lorsque l'utilisateur modifie les input text
      this.contentMessageMel.message = null;
    },
    setMFAOption(event) {
      this.mfaOption = event.target.id == 'buttonPrefYes' ? 'YES' : 'NO';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .aide {
  color: #192872;
}

#buttonPrefNo {
  background: none;
  border-radius: 0;
  height: auto;
  border-width: 0px 0px 1px 0px;
}
</style>
